import { faBookJournalWhills, faFemale, faHospital, faListAlt, faPeopleGroup, faPersonPregnant, faUserCircle, faVirus } from '@fortawesome/free-solid-svg-icons';
import { faTypo3 } from '@fortawesome/free-brands-svg-icons';

export function formatAuthor(str, taille) {
  str = str==null ? "...": str;
    if (str.length > taille) {
      return str.substring(0, taille) + '...';
    } else {
      return str.padEnd(taille, ' ');
    }
};

export function formatTitle (str, charsPerLine){
    if (str.length > charsPerLine * 3) {
      const lines = [
        str.substring(0, charsPerLine),
        str.substring(charsPerLine, charsPerLine * 2),
        str.substring(charsPerLine * 2, charsPerLine * 3) + '...'
      ];
      return lines.join('\n');
    } else {
      const lines = [
        str.substring(0, Math.min(charsPerLine, str.length)).padEnd(charsPerLine, ' '),
        str.substring(charsPerLine, Math.min(charsPerLine * 2, str.length)).padEnd(charsPerLine, ' '),
        str.substring(charsPerLine * 2, Math.min(charsPerLine * 3, str.length)).padEnd(charsPerLine, ' ')
      ];
      return lines.join('\n');
    }
}

export const categories = [
  {
    title:'Tous',
    code:'ALL',
    icon: faListAlt,
    id:0
  },
  {
    title:'Santé Sexuelle et Reproductrice',
    code:'SANTE_SEXUELLE',
    icon: faHospital,
    id:1
  },
  {
    title:'Prévention des Grossésses Précoces',
    code:'GROSSESSE_PRECOSE',
    icon: faPersonPregnant,
    id:2
  },
  {
    title:'Hygiene Menstruelle',
    code:'HYGENE_MENSTRUELLE',
    icon: faFemale,
    id:3
  },
  {
    title:'IST & VIH/SIDA',
    code:'VIH_IST',
    icon: faVirus,
    id:4
  },
  {
    title:'Violences Basées sur le Genre',
    code:'VVG',
    icon: faTypo3,
    id:5
  },
  {
    title:'Avortements Sécurisée',
    code:'IVG',
    icon: faPersonPregnant,
    id:6
  },
  {
    title:'Planning Familiale / Contraception',
    code:'PLANNING_FAMILLIAL',
    icon: faBookJournalWhills,
    id:7
  },
  {
    title:'LeaderShip Jeune',
    code:'YOUNGLEAD',
    icon: faPeopleGroup,
    id:8
  }
];

export const categoriesThemes = [
  {
    title:'Tous',
    code:'ALL',
    icon: faListAlt,
    id:0
  }
];
export const getName = (categorie)=>{  
  const response = categories.filter(value=> value.code===categorie);
  if(response.length===0){
      return categorie;
  }else{
      return response[0].title
  }
}